import { AudioManager } from "./audioManger";
import { MEventManager } from "./event";

export type MAudioItem = {
    isPlaying: boolean;
    id: string;
    audio: HTMLAudioElement;
    setSrc: Function;
    play: Function;
    pause: Function;
    stop: Function;
    destroy: Function;
}


type MAudioListen = {
    play?: Function;
    error?: Function;
    playing?: Function;
    ended?: Function;
    pause?: Function;
    timeupdate?: Function;
    setSrcCallback?: Function
};

let uid = 0;

const events = new MEventManager();
const audioManager = new AudioManager();

export class MAudio {
    public audio: HTMLAudioElement;
    public isPlaying: boolean = false;
    public id: string;
    public duration: number
    public currentTime: number

    private _callbackMap: Map<string, MAudioListen>;

    constructor(id: string) {
        this.audio = new Audio();
        this.audio.preload = "auto"
        this.currentTime = 0
        this.duration = 0
        this.id = id;
        this._callbackMap = events.get(id);
        this.bindEvents()
    }

    static listen(obj: MAudioListen): MAudioItem {
        const key = `audio_${++uid}`;
        events.add(key, obj);
        console.log('-----event-obj', obj);
        
        const audio = new MAudio(key);
        audioManager.add(audio);
        return audio;
    }

    setSrc(src: string) {
        this.audio.src = src;
        this.duration = this.audio.duration
        this.audio.load()
        this.audio.oncanplay = () => {
            this.duration = this.audio.duration
            if(this._callbackMap){
                this._callbackMap.forEach((item) => {
                    typeof item.setSrcCallback === 'function' && item.setSrcCallback.call(this)
                })
            }
        }
    }

    setCurrentTime(time: number) {
        this.audio.currentTime = time
    }

    play() {
        this.pause()
        if (this.isPlaying) {
            this.audio.pause();
        }
        this.audio.play();
    }

    pause() {
        let audios = audioManager.get();
        audios.forEach(({ audio, isPlaying }: MAudioItem) => {
            if(isPlaying) {
                audio.pause()
            }
        });
    }

    stop() {
        this.pause()
    }

    bindEvents() {
        ['play', 'playing', 'pause', 'ended', 'error', 'timeupdate'].forEach(event => {
            this.audio.addEventListener(event, () => {
                const self = this;
                if (event === 'timeupdate') {
                    self.currentTime = this.audio.currentTime
                    
                    self.isPlaying = true;
                } else {
                    self.isPlaying = false;
                }

                this._callbackMap.forEach(item => {
                    for (let i in item) {
                        if (i === event) item[i].call(self);
                    }
                });
            });
        });
    }

    destroy() {
        ['play', 'playing', 'pause', 'ended', 'error', 'timeupdate'].forEach(event => {
            this.audio.removeEventListener(event, () => {
                console.log(`removeEventListener instance ${event}`);
                this._callbackMap.forEach(item => {
                    for (let i in item) {
                        if (i === event) item[i].call(self);
                    }
                });
            });
        });
    }

    static stopAll() {
        audioManager.pause();
    }
}
